/* ============================================
   Xsavier widget — CSS pur, layout WhatsApp-like
   ============================================ */

*, *::before, *::after { box-sizing: border-box; }

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 15px;
  line-height: 1.4;
  color: #0f172a;
  background: #ece5dd;
  -webkit-font-smoothing: antialiased;
}

#xsavier-root, #root {
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #ece5dd;
}

button { font-family: inherit; font-size: inherit; border: none; cursor: pointer; }
input, textarea { font-family: inherit; font-size: inherit; }
a { color: #128c7e; }

/* ── Shell & header ──────────────────────────── */
.xs-shell {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #ece5dd;
}

.xs-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  background: #075e54;
  color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  position: sticky;
  top: 0;
  z-index: 20;
}
.xs-header-avatar {
  width: 38px; height: 38px;
  border-radius: 50%;
  background: #128c7e;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  flex-shrink: 0;
}
.xs-header-title { font-weight: 600; font-size: 15px; }
.xs-header-sub { font-size: 11px; opacity: 0.8; }
.xs-header-action {
  margin-left: auto;
  background: rgba(255, 255, 255, 0.15);
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.15s;
}
.xs-header-action:hover { background: rgba(255, 255, 255, 0.25); }

/* ── Main scroll area ─────────────────────────── */
.xs-main {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  max-width: 820px;
  width: 100%;
  margin: 0 auto;
}

/* ── Cards ───────────────────────────────────── */
.xs-card {
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  margin-bottom: 12px;
}
.xs-card-sub { background: #f8fafc; border: 1px solid #e2e8f0; box-shadow: none; }
.xs-card h2 { margin: 0 0 4px 0; font-size: 18px; font-weight: 600; }
.xs-card-desc { color: #64748b; font-size: 13px; margin: 0 0 12px 0; }

/* ── Buttons ─────────────────────────────────── */
.xs-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 9px 18px;
  border-radius: 22px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  border: none;
  white-space: nowrap;
}
.xs-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.xs-btn-primary { background: #128c7e; color: white; }
.xs-btn-primary:hover:not(:disabled) { background: #0e6b5f; }

.xs-btn-secondary { background: white; color: #0f172a; border: 1px solid #cbd5e1; }
.xs-btn-secondary:hover:not(:disabled) { background: #f1f5f9; }

.xs-btn-ghost { background: transparent; color: #64748b; padding: 6px 10px; }
.xs-btn-ghost:hover { color: #0f172a; background: rgba(0,0,0,0.04); }

.xs-btn-sm { padding: 6px 12px; font-size: 12px; border-radius: 14px; }

/* ── Inputs ──────────────────────────────────── */
.xs-field { display: block; margin-bottom: 12px; }
.xs-field-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 4px;
  color: #334155;
}
.xs-input, .xs-textarea {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: white;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.xs-input:focus, .xs-textarea:focus {
  border-color: #128c7e;
  box-shadow: 0 0 0 2px rgba(18, 140, 126, 0.15);
}
.xs-textarea { min-height: 88px; resize: vertical; line-height: 1.4; }

/* ── Lists / tiles ───────────────────────────── */
.xs-list { display: flex; flex-direction: column; gap: 8px; }
.xs-tile {
  width: 100%;
  background: white;
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 12px 14px;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.xs-tile:hover { border-color: #128c7e; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); }
.xs-tile-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
}
.xs-tile-title { font-weight: 600; font-size: 14px; }
.xs-tile-meta { font-size: 12px; color: #64748b; }

/* ── Badges ──────────────────────────────────── */
.xs-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
}
.xs-badge-green { background: #dcfce7; color: #166534; }
.xs-badge-blue { background: #dbeafe; color: #1e40af; }
.xs-badge-yellow { background: #fef3c7; color: #92400e; }
.xs-badge-gray { background: #e2e8f0; color: #475569; }
.xs-badge-red { background: #fee2e2; color: #991b1b; }

/* ── Step progress ───────────────────────────── */
.xs-steps {
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  background: white;
  border-bottom: 1px solid #e2e8f0;
}
.xs-step { flex: 1; text-align: center; min-width: 0; }
.xs-step-dot {
  width: 26px; height: 26px;
  border-radius: 50%;
  background: #e2e8f0;
  color: #64748b;
  margin: 0 auto 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
}
.xs-step-dot.done { background: #22c55e; color: white; }
.xs-step-dot.current { background: #075e54; color: white; }
.xs-step-label {
  font-size: 11px;
  font-weight: 500;
  color: #475569;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Chat (WhatsApp-like) ────────────────────── */
.xs-chat-header {
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.xs-chat-back {
  font-size: 20px;
  line-height: 1;
  background: transparent;
  color: #64748b;
  padding: 4px 8px;
  cursor: pointer;
}
.xs-chat-title { flex: 1; min-width: 0; }
.xs-chat-ref { font-size: 11px; color: #64748b; font-family: ui-monospace, monospace; }
.xs-chat-product {
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.xs-chat-area {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background-color: #ece5dd;
  background-image:
    linear-gradient(rgba(255,255,255,0) 0%, rgba(255,255,255,0) 100%),
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Cg fill='%23000' fill-opacity='0.03'%3E%3Cpath d='M30 20c-5 0-8 3-8 8s3 8 8 8 8-3 8-8-3-8-8-8z'/%3E%3C/g%3E%3C/svg%3E");
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.xs-bubble {
  max-width: 75%;
  padding: 8px 11px 6px;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.35;
  word-break: break-word;
  white-space: pre-wrap;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.08);
  position: relative;
  margin-bottom: 2px;
}
.xs-bubble-me { align-self: flex-end; background: #dcf8c6; border-bottom-right-radius: 2px; }
.xs-bubble-them { align-self: flex-start; background: white; border-bottom-left-radius: 2px; }
.xs-bubble-time {
  display: block;
  font-size: 10px;
  color: #667781;
  margin-top: 2px;
  text-align: right;
}
.xs-chat-divider {
  align-self: center;
  background: rgba(255, 255, 255, 0.8);
  color: #475569;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-style: italic;
  margin: 8px 0;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.xs-chat-footer {
  background: #f0f0f0;
  padding: 8px 12px;
  display: flex;
  gap: 8px;
  align-items: center;
  border-top: 1px solid #e2e8f0;
  position: sticky;
  bottom: 0;
}
.xs-chat-footer .xs-input { flex: 1; border-radius: 24px; background: white; padding: 10px 16px; }

/* ── Chips / symptoms ────────────────────────── */
.xs-chips { display: flex; flex-wrap: wrap; gap: 6px; }
.xs-chip {
  background: white;
  border: 1px solid #cbd5e1;
  color: #334155;
  padding: 5px 12px;
  border-radius: 16px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s;
}
.xs-chip:hover { border-color: #128c7e; color: #128c7e; }
.xs-chip.active { background: #128c7e; color: white; border-color: #128c7e; }

/* ── Alerts ──────────────────────────────────── */
.xs-alert {
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  margin-bottom: 12px;
}
.xs-alert-error { background: #fee2e2; color: #991b1b; border: 1px solid #fecaca; }
.xs-alert-info { background: #dbeafe; color: #1e40af; border: 1px solid #bfdbfe; }

/* ── Utility ─────────────────────────────────── */
.xs-row { display: flex; align-items: center; gap: 8px; }
.xs-row-between { display: flex; justify-content: space-between; align-items: center; gap: 8px; }
.xs-stack { display: flex; flex-direction: column; gap: 8px; }
.xs-muted { color: #64748b; font-size: 12px; }
.xs-mono { font-family: ui-monospace, SF Mono, Consolas, monospace; font-size: 12px; }
.xs-truncate { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* Scrollbars */
.xs-chat-area::-webkit-scrollbar,
.xs-main::-webkit-scrollbar { width: 8px; }
.xs-chat-area::-webkit-scrollbar-thumb,
.xs-main::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 4px; }

/* Responsive : occupe toute la hauteur de l'iframe */
@media (max-height: 100vh) {
  body { background: #ece5dd; }
}
